export default __webpack_public_path__ + "images/cd0ff1570d193f75dd1d48318db8b9ec-school.png";